import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../const";
import _ from 'lodash';
import { unAuthorized }  from '../../../../auth/Auth.ducks'
import { Service } from "../../../../service/service"

// Histosante actions

export const GET_HISTOSANTE_PENDING = "GET_HISTOSANTE_PENDING";
export const GET_HISTOSANTE_REJECTED = "GET_HISTOSANTE_REJECTED";
export const GET_HISTOSANTE_FULFILLED = "GET_HISTOSANTE_FULFILLED";

const loading = (state = {}, { type }) => {
  switch (type) {
    case GET_HISTOSANTE_PENDING:
      return true;
    case GET_HISTOSANTE_REJECTED:
    case GET_HISTOSANTE_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_HISTOSANTE_PENDING:
    case GET_HISTOSANTE_FULFILLED:
      return null;
    case GET_HISTOSANTE_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_HISTOSANTE_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;

    default:
      return null;
  }
};

// HISTOSANTE reducer
export default combineReducers({ loading, error, data });

export const getHistoSante = (tok,id) => {
  return (dispatch) => {
    dispatch({ type: GET_HISTOSANTE_PENDING })
    const response = Service.get(`${API}api/enfant/creche/enfants/${id}/dossier-medical`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: GET_HISTOSANTE_FULFILLED, payload: res })
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: GET_HISTOSANTE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

